export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14724.415e8c12.jpg";